import { render, staticRenderFns } from "./Grade10ResultForm.vue?vue&type=template&id=69965152&scoped=true&"
import script from "./Grade10ResultForm.vue?vue&type=script&lang=js&"
export * from "./Grade10ResultForm.vue?vue&type=script&lang=js&"
import style0 from "./Grade10ResultForm.vue?vue&type=style&index=0&id=69965152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69965152",
  null
  
)

export default component.exports